import React from 'react';
import coverbackground from '../../assets/pollutionb.jpg';
import ReusableMetricCard from '../../components/ReusableMetriccard/ReusableMetriccard';
import Up from '../../assets/up.png';

class ScrollPollution extends React.Component {
  render () { 
   return(
  
  <ReusableMetricCard             
    
        
        description="Pollution"
        trend={Up}
        metriclg="8 million"
        metricsm="tons per year"
        coverbackground={coverbackground}
     />
  
  );
 }
}   

export default ScrollPollution;